$('.form-control.error').on('focus', function (e) {
	e.preventDefault();
	$('.form-error').show().not($(this).next('.form-error')).hide();
});



// WEBPACK FOOTER //
// ./_dev/blocks/form-control/form-control.js